import React from 'react';
import styled from '@emotion/styled';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import mapMarker from '../assets/svgs/map-marker.svg';
import L from 'leaflet';

const ModalBackground = styled.div`
  /* Remove fixed positioning and overlay behavior */
  position: relative;
  width: 100%;
  height: 400px; /* adjust height as needed */
  background: #fff; /* optional, mimic modal content */
  border-radius: 15px;
  overflow: hidden;
  margin-top: 20px;
  box-shadow: 0px 4px 10px rgba(0,0,0,0.1);

  @media (max-width: 768px) {
    height: 250px;
  }
`;

const ModalContent = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const CloseButton = styled.button`
  display: none; /* hide close button since map is always visible */
`;

const InlineMap = ({ position }) => {
  const customIcon = L.icon({
    iconUrl: mapMarker,
    iconSize: [38, 38],
    iconAnchor: [19, 38], 
    popupAnchor: [0, -38],
  });

  return (
    <ModalBackground>
      <ModalContent>
        <CloseButton />
        <MapContainer center={position} zoom={16} style={{ height: '100%', width: '100%' }}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&copy; OpenStreetMap contributors"
          />
          <Marker position={position} icon={customIcon}>
            <Popup>Amenity Location</Popup>
          </Marker>
        </MapContainer>
      </ModalContent>
    </ModalBackground>
  );
};

export default InlineMap;
